/* eslint-disable no-console */
import { client } from "."; // ← cliente oficial de Supabase

// Escritura aislada de la columna edificiosOk (usuarios rol='edificio').
// Aditiva/aislada — NO usar ni tocar updateUsuario.js, que escribe `email` de forma
// incondicional (llamarlo sin email dejaría el correo en NULL). Acá se toca SOLO
// edificiosOk. `edificiosOk`: CSV de ids sin espacios, o null si no hay edificios.
export const setUsuarioEdificios = async (id, edificiosOk) => {
  const { data, error } = await client.from("usuarios").update({ edificiosOk }).eq("id", id).select();

  if (error) {
    console.error("Error en setUsuarioEdificios:", error);
  }

  return { data, error };
};
